import * as ROUNDS_API from '@/constants/roundsApiEndpoints'
import router from '@/router'

// Team Service Plugin
class TeamService {
  constructor(Vue) {
    var self = this;
    this.Vue = Vue;
    this._store = Vue.teamsStore;
    this.watch = new Vue({
      data() {
        return {
          updateCounter: 1,
          permalinks: []
        }
      },
      computed: {
        currentTeamId() {
          // stub update counter forces update of computed properties when dependencies change
          var stub = this.updateCounter;
          if (self.Vue.currentTeam && self.Vue.currentTeam.teamId) {
            return self.Vue.currentTeam.teamId
          } else if (!!router.currentRoute && !!router.currentRoute.params && !!router.currentRoute.params.teamId) {
            return router.currentRoute.params.teamId
          }
          return null;
        },
        currentTeam() {
          return self.getTeam(this.currentTeamId)
        },
        currentUserTeamIds() {
          if (!!this.$auth.user().teams) {
            return this.$auth.user().teams
          } else {
            return []
          }
        },
        currentUserTeams() {
          return self.teams.filter(team => !!this.currentUserTeamIds.filter(it => it === team.teamId).length);
        }
      }
    })

    // Install before hook to router to set currentTeam when teamId parameter exists in route
    router.beforeHooks.push((to, from, next) => {
      if (to.params && to.params.teamId) {
        this.Vue.set(this.Vue, 'currentTeam', this.getTeam(to.params.teamId));
      } else {
        this.Vue.set(this.Vue, 'currentTeam', null);
      }
      this.watch.updateCounter++;
      next();
    })

    // Fetch data on instantiation
    if (this.Vue.$auth.watch.authenticated) {
      this.refreshData().then((teams) => {
        this.Vue.$roomService.preCacheRoomsForCurrentUserTeams();
      });
    } else {
      this.Vue.$auth.userLoginSuccessful().then(() => {
        this.refreshData().then((teams) => {
          this.Vue.$roomService.preCacheRoomsForCurrentUserTeams();
        });
      });
    }
  }

  async refreshData() {
    try {
      var options = {
        credentials: true,
        headers: {
          'Content-Type': 'application/json'
        }
      }
      
      const url = ROUNDS_API['API_ENDPOINT_TEAMS'];
      const res = await this.Vue.http.get(url);
      const response = await res.json();

      // Success Calback
      if (!response || response.errorMessage) {
        // Error Callback
        this.refreshDataFailureCallback(response);
      } else {
        if (!!response.length) {
          this.watch.updateCounter++;
          this._store.dispatch('updateTeams', { items: response });
          // TODO: Consider looping through user's teams, and pre-fetching room data for each team
        } else {
          this.refreshDataFailureCallback(response);
        }
      }
    } catch (err) {
      debugger;
      this.refreshDataFailureCallback(err);

    }
  }

  refreshDataFailureCallback(response) {
    // Log exception in Google Analytics
    if (response && (response.length || Object.keys(response).length)) {
      const exception = response.errorMessage || response;
      this.Vue.$ga.exception(exception);
    }

    // Log user out if request authorization fails
    if (response.errorMessage && response.errorMessage.match(/^E_AUTH_.+/)) {
      this.Vue.$auth.logout().then(router.accessDenied);
    }
  }

  get currentTeamId() {
    return this.watch.currentTeamId
  }

  get currentTeam() {
    return this.watch.currentTeam
  }

  get teams() {
    return this._store.state.TeamsCache.teams;
  }

  get currentUserTeams() {
    return this.watch.currentUserTeams
  }

  get currentUserTeamIds() {
    return this.watch.currentUserTeamIds
  }
  get permalinks () {
    return this.watch.permalinks
  }

  set permalinks (permalinks) {
    this.watch.permalinks = permalinks;
  }

  getTeam(teamId) {
    var teams = this.teams.filter(team => team.teamId === teamId);
    return !!teams.length ? teams.pop() : null;
  }

  getPermalinksForTeam (teamId) {
    const options = {
      params: {
        teamId: teamId
      }
    };
    this.Vue.http.get(ROUNDS_API['API_ENDPOINT_SMARTSHEETS'], options).then(res => res.json()).then(
      // Success Calback
      response => {
        // console.log("response", response);
        if (!response || response.errorMessage) {
          // Error Callback
          this.refreshDataFailureCallback(response);
        } else {
          this.permalinks = response;
        }
      });
  }

  reset() {
    this._store.dispatch('clearCache');
  }
}

const teamService = {
  install: function (Vue, options) {
    const instance = new TeamService(Vue);
    Vue.prototype.$teamService = instance
    Vue.$teamService = instance;
  }
};

export default teamService;



// WEBPACK FOOTER //
// ./src/services/TeamService.js